
<template>

        <div class="search-bar">
            <input id="inputSearch" type="text" v-model="searchTerm" :placeholder="$t('searchBox.placeholder')" class="search-bar__input" />
            <b-icon-search v-if="this.searchTerm == ''" class="search-bar__icon" />
            <b-icon-x-circle-fill v-else class="color-red search-bar__icon curser-pointer" @click="ClearSearch()" />
        </div>

</template>

<script>

    export default {
        name: 'searchBox',
        props: [],
        data: function () {

            return {

            }

        },
        mounted: function () {

        },
        methods: {
            ClearSearch: function () {
                document.getElementById('inputSearch').value = '';
                this.searchTerm = '';
            }
        },
        computed: {
            searchTerm: {
                get: function () {
                    return this.$store.state.searchTerm
                },
                set: function (newValue) {
                    this.$store.commit('SET_searchTerm', newValue)
                }
            }
        }
    }
</script>
